$(document).ready(function () {
  $(".accordions").on("click", ".accordions_title", function() {
    $(this).toggleClass("active").next().slideToggle();
  });
});
